var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedNumberThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#BDBDBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.476 13.864C9.714 15.978 11.17 17.21 13.466 17.21C15.566 17.21 16.994 15.964 16.994 14.312C16.994 13.248 16.434 12.38 15.538 11.974V11.946C16.308 11.554 16.728 10.896 16.728 10.07C16.728 8.502 15.3 7.382 13.326 7.382C12.332 7.382 11.492 7.634 10.82 8.152C10.162 8.656 9.756 9.342 9.63 10.196L11.576 10.532C11.73 9.678 12.36 9.188 13.326 9.188C14.166 9.188 14.726 9.636 14.726 10.308C14.726 10.98 14.194 11.372 13.256 11.372H12.458V12.926H13.424C14.446 12.926 14.992 13.346 14.992 14.144C14.992 14.928 14.418 15.39 13.466 15.39C12.192 15.39 11.632 14.83 11.408 13.5L9.476 13.864Z",
    fill: "#201E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedNumberThree);
export default __webpack_public_path__ + "static/media/rounded-number-three.45e90c0f3f8aaee72bdb0300615940bf.svg";
export { ForwardRef as ReactComponent };